namespace GeniuzPOS.Purchase {
    export interface ReportDailyPIForm {
        SysDocNo: Serenity.StringEditor;
        PurIvNo: Serenity.StringEditor;
        DtList: PoPurInvoiceDtAppEditor;
    }

    export class ReportDailyPIForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.ReportDailyPI';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReportDailyPIForm.init)  {
                ReportDailyPIForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = PoPurInvoiceDtAppEditor;

                Q.initFormType(ReportDailyPIForm, [
                    'SysDocNo', w0,
                    'PurIvNo', w0,
                    'DtList', w1
                ]);
            }
        }
    }
}
